<template>
  <div class="goods">
    <!-- 商品內容 -->

    <!-- 分類 -->
    <div class="menu-wrapper" ref="menuScroll">
      <ul>
        <!-- 專場 -->
        <li class="menu-item" :class="{'current':currentIndex===0}" @click="selectMenu(0)">
          <p class="text">
            <img :src="container.tag_icon" v-if="container.tag_icon" class="icon" />
            {{container.tag_name}}
          </p>
        </li>
        <li class="menu-item" v-for="(item,index) in goods" :class="{'current':currentIndex===index+1}" @click="selectMenu(index+1)">
          <p class="text">
            <img :src="item.icon" v-if="item.icon" class="icon" />
            {{item.name}}
          </p>
          <i class="num" v-show="calculateCount(item.spus)">{{ calculateCount(item.spus) }}</i>
        </li>
      </ul>
    </div>

    <!-- 商品列表 -->
    <div class="foods-wrapper" ref="foodScroll">
      <ul>
        <!-- 專場 -->
        <li class="container-list food-list-hook">
          <div v-for="item in container.operation_source_list">
            <img :src="item.pic_url" />
          </div>
        </li>

        <!-- 具體分類 -->
        <li v-for="item in goods" class="food-list food-list-hook">

          <h3 class="title">{{item.name}}</h3>
          <!-- 具體商品列表 -->
          <ul>
            <li v-for="food in item.spus" class="food-item" @click="showDetail(food)">
              <div class="icon" :style="head_bg(food.picture)"></div>
              <div class="content">
                <h3 class="name">{{food.name}}</h3>
                <p class="desc" v-if="food.description">{{food.description}}</p>
                <div class="extra">
                  <span class="saled">{{food.month_saled_content}}</span>
                  <span class="praise">{{food.praise_content}}</span>
                </div>
                <img class="product" :src="food.product_label_picture" />
                <p class="price">
                  <span class="text">${{food.min_price}}</span>
                  <span class="unit">/{{food.unit}}</span>
                </p>
              </div>

              <div class="cartcontrol-wrapper">
                <Cartcontrol
                  :food='food'
                ></Cartcontrol>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>




    <!-- 購物車組件 -->

    <!-- <Shopcart
    :shipping_fee_tip="poiInfo.shipping_fee_tip"
    :min_price_tip="poiInfo.min_price_tip"
    :selectFoods="selectFoods"
    ></Shopcart> -->
    <Shopcart
      :poiInfo="poiInfo"
      :selectFoods="selectFoods"
    ></Shopcart>




    <!-- 商品詳情 -->
    <Food :food="selectedFood" ref="foodView"></Food>

  </div>
</template>
<script>
// 引入BetterScroll
import BScroll from '@better-scroll/core'
import Shopcart from '../Shopcart/Shopcart'
import Cartcontrol from '../Cartcontrol/Cartcontrol'
import Food from '../Food/Food'


  export default {
    data(){
        return{
          container:{},
          goods:[],
          poiInfo:{},
          listHeight:[],
          scrollY:0,
          menuScroll:{},
          foodScroll:{},
          selectedFood:{},
          }
    },
    created () {    //發起異步請求，獲取資料

        var that =  this

      //通過axios發起get請求
        this.$axios.get('/api/goods')
      .then(function (response) {   //獲取數據
        // handle success
        var dataSource = response.data.data

        if (dataSource.code == 0){

          that.container = dataSource.data.container_operation_source
          that.goods = dataSource.data.food_spu_tags
          that.poiInfo = dataSource.data.poi_info
          // console.log(that.container)
          // console.log(that.goods)




                  // 調用滾動的初始方法
                  // that.initScroll();
                  // 開始時，DOM元素沒有渲染，及高度是問題
                  // 在獲取到數據之後，且DOM已經被渲染，表示列表高度是沒問題的

                  //nextTick
                  that.$nextTick( ()=>{
                    //DOM已經更新
                    that.initScroll();
              // 计算分类区间高度
						 	that.calculateHeight();
                  })
        }
      })
      .catch(function (error) {   //出錯處理
        // handle error
        console.log(error)
      });
    },
    computed:{
      // 計算屬性(不能傳遞參數)

      // head_bg() {
			// 	return
			// },
      currentIndex(){
        // console.log(this.listHeight);
        // 根據右側滾動位置，確定對應的索引下標
        for(let i=0;i<this.listHeight.length;i++){
          // 獲取商品區間範圍
          let height1 = this.listHeight[i]
          let height2 = this.listHeight[i+1]

          // 是否在上述區間中
          // console.log(this.scrollY,height1,height2);
          if (!height2||(this.scrollY>=height1 && this.scrollY<height2)){
            // console.log(i)
            return i
          }
        }
        return 0
      },
      // selectFoods(){
      //   let foods = []

      //   this.goods.forEach((good)=>{
      //     good.sups.forEach((food)=>{
      //    //      \\===>此處應為spus，粗心錯
      //       console.log(food)
      //       if(food.count>0){
      //         foods.push(food)
      //       }
      //     })
      //   })
      //   return foods
      // },


      // 此功能的作用是提取後供Shopcart中的selectFoods讀取
      selectFoods() {
				let foods = [];

				this.goods.forEach((good)=>{
					good.spus.forEach((food)=>{
						if(food.count>0){
							foods.push(food);
						}
					});
				});

				return foods;
			},
    },
    components:{
      BScroll,
      Shopcart,
      Cartcontrol,
      Food,
    },
    methods:{
      // 方法，從Header中複製
      head_bg(imgName) {
				return "background-image: url(" + imgName + ");"
			},

      // 滾動的初始化
      initScroll(){
        // ref屬性就是用來綁定某個dom元素或某組件，然後在this.$refs裡面
        this.menuScroll=new BScroll(this.$refs.menuScroll,{
          click:true
        })
        this.foodScroll=new BScroll(this.$refs.foodScroll,{
          probeType:3,
          click:true
          // 參考以下網頁內容:https://better-scroll.github.io/docs/zh-CN/guide/base-scroll-options.html#probetype

                // 派发 scroll 的场景分为两种：
                // 1. 手指作用在滚动区域（content DOM）上;
                // 2. 调用 scrollTo 方法或者触发 momentum 滚动动画（其实底层还是调用 scrollTo 方法）

                // 对于 v2.1.0 版本，对 probeType 做了一次统一

                // 1. probeType 为 0，在任何时候都不派发 scroll 事件，
                // 2. probeType 为 1，仅仅当手指按在滚动区域上，每隔 momentumLimitTime 毫秒派发一次 scroll 事件，
                // 3. probeType 为 2，仅仅当手指按在滚动区域上，一直派发 scroll 事件，
                // 4. probeType 为 3，任何时候都派发 scroll 事件，包括调用 scrollTo 或者触发 momentum 滚动动画
        })

        // 添加滾動監聽事件
        this.foodScroll.on('scroll', (pos) =>{
          // console.log(pos.y)

          // 取絕對值後去掉小數
          this.scrollY = Math.abs(Math.round(pos.y))
        })
      },
      calculateHeight(){
        // console.log("calculateHeight test")
        // 通過$refs或取到相對應的元素
        let foodList = this.$refs.foodScroll.getElementsByClassName('food-list-hook')

        // 添加到數組區間
        // 0~216 第一區間(專場)
        // 217~1342 第二區間(熱銷)
        let height = 0
        this.listHeight.push(height)
        for(let i=0; i<foodList.length; i++){
          let item=foodList[i]

          // 累加
          height += item.clientHeight

          this.listHeight.push(height)
        }
      },
      selectMenu(index){
        // console.log(index)
        let foodList = this.$refs.foodScroll.getElementsByClassName('food-list-hook')

        // 根據下標，滾動到相對應的元素
        let el = foodList[index]

        // 滾動到對應元素位置
        this.foodScroll.scrollToElement(el,250)
      },

      //計算目前選中的商品個數
      calculateCount(spus){
        let count = 0
        spus.forEach((food)=>{
          if (food.count>0){
            count += food.count
          }
        })
        return count
      },
      showDetail(food){
        // 傳值


        // this.selectFood = food
        // 打錯字


        this.selectedFood = food

        // 顯示詳情頁
        this.$refs.foodView.showView()
      }
    }
  }
</script>
<style>
    @import url("Goods.css");
</style>



// WEBPACK FOOTER //
// src/components/Goods/Goods.vue